import React from 'react';
import { Button, Card, CardBody, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, ListGroup, ListGroupItem, Pagination, PaginationItem, PaginationLink, Row, UncontrolledDropdown } from 'reactstrap';

import getChartColorsArray from '../../../../../Components/Common/ChartsDynamicColor';
import ReactApexChart from 'react-apexcharts';

// Import Images



const UpcomingActivity = () => {

    const OtherWidgetsCharts = ({ dataColors, seriesData }) => {
        var areachartbitcoinColors = getChartColorsArray(dataColors);
        var options = {
            chart: {
                width: 140,
                type: "area",
                sparkline: {
                    enabled: true,
                },
                toolbar: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
                width: 1.5,
            },
            fill: {
                type: "gradient",
                gradient: {
                    shadeIntensity: 1,
                    inverseColors: false,
                    opacityFrom: 0.45,
                    opacityTo: 0.05,
                    stops: [50, 100, 100, 100],
                },
            },
            colors: areachartbitcoinColors,
        };

        const safeSeries = Array.isArray(seriesData)
            ? seriesData.map(seriesItem => ({
                ...seriesItem,
                data: Array.isArray(seriesItem?.data) ? [...seriesItem.data] : [],
            }))
            : [];

        const safeOptions = JSON.parse(JSON.stringify(options));

        return (
            <React.Fragment>
                <ReactApexChart dir="ltr"
                    options={safeOptions}
                    series={safeSeries}
                    type="area"
                    height={40}
                    className="apex-charts"
                />
            </React.Fragment>
        );
    };

    const generateRandomValues = (count, min = 0, max = 150) => {
        return Array.from({ length: count }, () => Math.floor(Math.random() * (max - min + 1)) + min);
    };

    const chartDataOptions = [
        {
            id: 1,
            title: "Biomasa",
            value: "ND Ton",
            persantage: "ND",
            series: [{
                name: "Results",
                data: generateRandomValues(50, 100, 200),
            }],
            dataColors: '["--vz-success" , "--vz-transparent"]'
        },
        {
            id: 2,
            title: "Peso Promedio",
            value: "ND Kg",
            persantage: "ND",
            series: [{
                name: "Results",
                data: generateRandomValues(50, 100, 200),
            }],
            dataColors: '["--vz-danger" , "--vz-transparent"]'
        },
        {
            id: 3,
            title: "N° Peces",
            value: "ND uni",
            persantage: "ND",
            series: [{
                name: "Results",
                data: generateRandomValues(48, 1000, 5000),
            }],
            dataColors: '["--vz-warning" , "--vz-transparent"]'
        },
        {
            id: 3,
            title: "SFR",
            value: "ND",
            persantage: "ND",
            series: [{
                name: "Results",
                data: generateRandomValues(5, 1, 2),
            }],
            dataColors: '["--vz-info" , "--vz-transparent"]'
        }
    ]

    return (
        <React.Fragment>
            <Row className="m-0 p-0 h-100" >
                {(chartDataOptions || []).map((item, key) => (
                    <Col key={key} className="m-0 p-0">
                        <Card className="h-100">
                            <CardBody className="m-0" style={{ padding: '5px 5px 0px 10px' }}>
                                <div className="d-flex m-0 p-0">
                                    <div className="flex-grow-1">
                                        <Row className='m-0 p-0'>
                                            <Col md={6} className='m-0 p-0'>
                                                <h3 className="m-0">{item.value}</h3>
                                                <h5 className="m-0">{item.title}</h5>
                                            </Col>
                                            <Col md={6} className='m-0 p-0'>
                                                <OtherWidgetsCharts dataColors={item.dataColors} seriesData={item.series} /></Col>
                                            <Col md={12} className='m-0 pt-2 text-muted text-center'>
                                                <span className="badge bg-light text-success mb-0">
                                                    <i className="ri-arrow-up-line align-middle"></i> {item.persantage} %
                                                </span> según el mes pasado
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        </React.Fragment>

    );
};

export default UpcomingActivity;